import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useReportSurgerie } from '../../hooks/useReportSurgerie';

type ReportSurgerieMenuProps = {
  anchorEl: HTMLButtonElement | null;
};

const ReportSurgerieMenu: React.FC<ReportSurgerieMenuProps> = ({ anchorEl }) => {
  const { selectedSurgerie, setSelectedSurgerie, setAnchorEl } = useReportSurgerie();

  function onClose() {
    setSelectedSurgerie(null);
    setAnchorEl(null);
  }

  function handlePrint() {
    window.open(`/surgeries/${selectedSurgerie?.status}/${selectedSurgerie?.id_int}/print`, '_blank');
    onClose();
  }

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={handlePrint}>Imprimir orçamento</MenuItem>
    </Menu>
  );
};

export default ReportSurgerieMenu;
